import React from 'react';


function ErrorMsg({children}) {

  return (
    <div className={ `errorWrapper` }>{ children || ' ' }</div>
  );
}

export default ErrorMsg;